var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{attrs:{"data-label":_vm.deliveryOption.orderLabel},domProps:{"value":_vm.deliveryOption.value}},[_vm._v(" "+_vm._s(_vm.deliveryOption.label)+" "+_vm._s(_vm.labelPrice)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }